import { defineMessages } from 'react-intl';

export default defineMessages({
    scheduleAdd: {
        id: 'CPMIpolicycommon.directives.schedules.table.Add',
        defaultMessage: 'Add',
    },
    scheduleCancel: {
        id: 'CPMIpolicycommon.directives.schedules.table.Cancel',
        defaultMessage: 'Cancel',
    },
    scheduleAddAnother: {
        id: 'CPMIpolicycommon.directives.schedules.table.Add Another',
        defaultMessage: 'Add Another',
    },
    scheduleDone: {
        id: 'CPMIpolicycommon.directives.schedules.table.Done',
        defaultMessage: 'Done',
    },
    scheduleRemoveTitle: {
        id: 'CPMIpolicycommon.directives.schedules.table.Remove Scheduled Item?',
        defaultMessage: 'Remove Scheduled Item?',
    },
    scheduleRemove: {
        id: 'CPMIpolicycommon.directives.schedules.table.Are you sure you want to remove this item?',
        defaultMessage: 'Are you sure you want to remove this item?',
    },
    noItems: {
        id: 'CPMIpolicycommon.directives.schedules.table-readonly.No items',
        defaultMessage: 'No items'
    },
    delete: {
        id: 'CPMIpolicycommon.directives.schedules.table.Delete',
        defaultMessage: 'Delete'
    },
    cancel: {
        id: 'CPMIpolicycommon.directives.schedules.table.Cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'CPMIpolicycommon.directives.schedules.table.Save',
        defaultMessage: 'Save'
    }
});
